import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell, { storedSession } from '../components/AppShell';
import JobBoardsTab from '../components/org/JobBoardsTab';
import OrgSetupTab from '../components/org/OrgSetupTab';
import TeamTab from '../components/org/TeamTab';
import WorkflowBuilder from '../components/workflows/WorkflowBuilder';
import CandidateDatabase from '../components/candidates/CandidateDatabase';
import { Tabs, ToastProvider } from '../components/ui/Kit';

const TABS = [
  { key: 'team', label: 'Team members' }, { key: 'setup', label: 'Org setup' },
  { key: 'workflows', label: 'Approval workflows' }, { key: 'boards', label: 'Job board integration' },
  { key: 'candidates', label: 'Candidate database' },
];

// Organization (replaces Manage Users for company admins): Team members | Org setup | Approval workflows |
// Job board integration | Candidate database (bundle 4a-2; also at /candidates for Recruit holders). Company admins only — the server checks every call.
export default function OrganizationPage() {
  const navigate = useNavigate();
  const { user } = storedSession();
  const initial = new URLSearchParams(window.location.search).get('tab');
  const [tab, setTab] = useState(TABS.some((t) => t.key === initial) ? initial : 'team');
  useEffect(() => {
    if (!localStorage.getItem('token')) navigate('/');
    else if (user.role !== 'company_super_admin') navigate(user.role === 'master_admin' ? '/manage-users' : '/dashboard/user');
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const change = (k) => { setTab(k); window.history.replaceState(null, '', `/organization?tab=${k}`); };
  if (user.role !== 'company_super_admin') return null;
  return (
    <ToastProvider>
      <AppShell active="organization">
        <h1 className="text-2xl font-extrabold text-[#0F172A]">Organization</h1>
        <p className="text-sm text-[#64748B] mt-1 mb-5">People, structure and how jobs are approved and assigned.</p>
        <Tabs tabs={TABS} active={tab} onChange={change} label="Organization sections" />
        <div className="pt-5" role="tabpanel" id={`panel-${tab}`} aria-labelledby={`tab-${tab}`}>
          {tab === 'team' && <TeamTab me={user} />}
          {tab === 'setup' && <OrgSetupTab />}
          {tab === 'workflows' && <WorkflowBuilder onOpenSetup={() => change('setup')} />}
          {tab === 'boards' && <JobBoardsTab companyId={user.company_id} />}
          {tab === 'candidates' && <CandidateDatabase basePath="/organization" />}
        </div>
      </AppShell>
    </ToastProvider>
  );
}
